module.exports = {
	env: 'production',
	apiUrl: '/v1',
	authConfig: {}
}
